<div class="bg"></div>
<div class="background" [ngStyle]="style"></div>
    <span class="slider" *ngIf="vgSlider"></span>